import { FC } from 'react'
import ActionButton from 'src/components/ActionButton'

type buttonProps = {
  type: 'primary' | 'secondary' | 'warning'
  name:
    | 'Create'
    | 'Cancel'
    | 'Delete'
    | 'Rename'
    | "Don't Use"
    | 'Use Anyway'
    | 'Confirm'
    | 'End'
  onClick?: () => void
  disabled?: boolean
  htmlButtonType: 'submit' | 'button'
}

type ModalButtonsProps = {
  firstButton: buttonProps
  secondButton: buttonProps
}

const ModalButtons: FC<ModalButtonsProps> = ({ firstButton, secondButton }) => {
  return (
    <div className="flex justify-end mt-6">
      <ActionButton
        type={firstButton.type}
        padding="sm"
        ariaLabel={firstButton.name}
        onClick={firstButton.onClick}
        styles="mr-2"
        disabled={!!firstButton.disabled}
        htmlButtonType="button"
      >
        {firstButton.name}
      </ActionButton>

      <ActionButton
        type={secondButton.type}
        padding="sm"
        ariaLabel={secondButton.name}
        onClick={secondButton.onClick}
        disabled={!!secondButton.disabled}
        htmlButtonType={secondButton.htmlButtonType}
      >
        {secondButton.name}
      </ActionButton>
    </div>
  )
}

export default ModalButtons
